var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdCardTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87986 5.25H25.618C27.0712 5.25 28.25 6.40821 28.25 7.83659V21.4134C28.25 22.8427 27.0712 24 25.618 24H4.87986C3.42762 24 2.25 22.8427 2.25 21.4134V7.83659C2.25 6.40845 3.42762 5.25 4.87986 5.25ZM16.4502 18.9936H21.6878V17.2705H16.4502V18.9936ZM16.4501 15.1811H24.9703V13.458H16.4501V15.1811ZM16.4501 11.3686H24.9703V9.64551H16.4501V11.3686ZM11.6565 9.6945C11.2587 9.30479 10.7188 9.08569 10.1563 9.08569L10.1563 9.08577C9.59433 9.08886 9.05657 9.30898 8.6593 9.69767C8.26256 10.0868 8.03788 10.6137 8.03473 11.1642C8.03473 11.7153 8.25832 12.2442 8.65615 12.634C9.05398 13.0237 9.5938 13.2428 10.1563 13.2428C10.7189 13.2428 11.2587 13.0237 11.6565 12.634C12.0543 12.2442 12.2779 11.7153 12.2779 11.1642C12.2779 10.6131 12.0543 10.0842 11.6565 9.6945ZM8.13526 14.7944C6.86932 15.3371 5.89269 16.3739 5.44174 17.6538C5.37754 17.824 5.42438 18.0152 5.55961 18.1389C6.785 19.2946 8.41988 19.94 10.121 19.94C11.8222 19.94 13.457 19.2947 14.6825 18.1389C14.8177 18.0152 14.864 17.824 14.8003 17.6538C14.349 16.3739 13.3728 15.3372 12.1068 14.7944C10.8409 14.251 9.40072 14.251 8.13526 14.7944Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardTemplate);
export default __webpack_public_path__ + "static/media/IDCardTemplate.325b5931010ba3e87ffc49dab2bed3f8.svg";
export { ForwardRef as ReactComponent };